import { ParentState } from "@hopper-b2b/checkout";
import { phoneRegex } from "@hopper-b2b/utilities";
import type { FlightMachineContext } from "../types";
import { uberEmailRegex } from "../utilities";

export const contactInformationGuards = {
  contactContinue: (ctx: FlightMachineContext) => {
    const contactInfo = ctx[ParentState.contactInformation].contactInfo;
    return (
      contactInfo?.email &&
      contactInfo.phoneNumber &&
      uberEmailRegex.test(contactInfo.email) &&
      phoneRegex.test(contactInfo.phoneNumber)
    );
  },
};
